// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/dialog.scss
// module id = 95
// module chunks = 0